import _ from 'lodash';
import { createReducer, on, ActionReducer } from '@ngrx/store';
import * as VirtualEventActions from './data.actions';

export interface State {
  id: string,
  sponsorSearch: string,
  slideSearch: string,
}

export const initialState: State = {
  id: null,
  sponsorSearch: '',
  slideSearch: ''
};

export const dataReducer: ActionReducer<State> = createReducer<State>(
  initialState,

  on(VirtualEventActions.loadVirtualEvent, state => state),
  on(VirtualEventActions.loadVirtualEventSuccess, (state, action) => {
    return {
      ...state,
      ...action.data
    };
  }),
  on(VirtualEventActions.loadVirtualEventFailure, (state, action) => state),

  on(VirtualEventActions.updateVirtualEvent, state => state),
  on(VirtualEventActions.updateVirtualEventSuccess, (state, action) => state),
  on(VirtualEventActions.updateVirtualEventFailure, (state, action) => state),

  on(VirtualEventActions.updateVirtualEventStream, state => state),
  on(VirtualEventActions.updateVirtualEventStreamSuccess, (state, action) => state),
  on(VirtualEventActions.updateVirtualEventStreamFailure, (state, action) => state),

  on(VirtualEventActions.updateVirtualEventStatus, state => state),
  on(VirtualEventActions.updateVirtualEventStatusSuccess, (state, action) => {
    return {
      ...state,
      ...action.data
    };
  }),
  on(VirtualEventActions.updateVirtualEventStatusFailure, (state, action) => state),

  on(VirtualEventActions.updateVirtualEventPresent, state => state),
  on(VirtualEventActions.updateVirtualEventPresentSuccess, (state, action) => state),
  on(VirtualEventActions.updateVirtualEventPresentFailure, (state, action) => state),

  on(VirtualEventActions.finalizeVirtualEventAuctionItem, state => state),
  on(VirtualEventActions.finalizeVirtualEventAuctionItemSuccess, (state, action) => state),
  on(VirtualEventActions.finalizeVirtualEventAuctionItemFailure, (state, action) => state),

  on(VirtualEventActions.finalizeVirtualEventAuction, state => state),
  on(VirtualEventActions.finalizeVirtualEventAuctionSuccess, (state, action) => state),
  on(VirtualEventActions.finalizeVirtualEventAuctionFailure, (state, action) => state),

  on(VirtualEventActions.closeVirtualEventSilentAuction, state => state),
  on(VirtualEventActions.closeVirtualEventSilentAuctionSuccess, (state, action) => state),
  on(VirtualEventActions.closeVirtualEventSilentAuctionFailure, (state, action) => state),

  on(VirtualEventActions.removeVirtualEventAuctionBid, state => state),
  on(VirtualEventActions.removeVirtualEventAuctionBidSuccess, (state: any, { payload }) => {
    const { currentItem: { optionInfo: { currentBids }}} = state;
    _.remove(currentBids, (bid) => {
      return payload.bidId === bid.id;
    })
    return _.cloneDeep(state);
  }),
  on(VirtualEventActions.removeVirtualEventAuctionBidFailure, (state, action) => state),

  on(VirtualEventActions.showVirtualEventAuctionMulti, state => state),
  on(VirtualEventActions.showVirtualEventAuctionMultiSuccess, (state, action) => state),
  on(VirtualEventActions.showVirtualEventAuctionMultiFailure, (state, action) => state),

  on(VirtualEventActions.updateVirtualEventData, (state, action) => {
    return {
      ...action.payload
    };
  }),

  on(VirtualEventActions.updateVirtualEventDataOptionInfo, (state: any, action) => {
    const { payload } = action;
    const campaign = _.find(payload, element => {
      const { campaignData } = element;
      return campaignData.id === _.get(state, 'currentItem.currentCampaign', null);
    });
    const campaignData = _.get(campaign, 'campaignData', null);
    const options = _.get(campaignData, 'campaignTypeData.presetOptions', []);
    const option = _.find(options, element => element.id === _.get(state, 'currentItem.currentOption', null)) || null;

    /* Fast Fix BEGIN */
    let currentItem = null;
    if(_.isNull(option) === false) {
      option.currentBids = _.get(state, 'currentItem.optionInfo.currentBids', []) || [];
      currentItem = {
        ...state.currentItem,
        optionInfo: option
      }
    } else {
      currentItem = {
        ...state.currentItem,
      }
    }
    /* Fast Fix END */
    return {
      ...state,
      currentItem: {
        ...currentItem
      }
    }
  }),

  on(VirtualEventActions.updateVirtualEventCurrentItem, (state: any, action: any) => {
    const campaignData = _.get(action.payload, 'currentItem.campaignData', null);
    const optionInfo = _.get(action.payload, 'currentItem.optionInfo', null);
    return {
      ...state,
      currentItem: {
        ...state.currentItem,
        campaignData,
        currentCampaign: _.get(campaignData, 'id', null),
        optionInfo,
        currentOption: _.get(optionInfo, 'id', null)
      }
    };
  }),

  on(VirtualEventActions.clearVirtualEventData, (state) => {
    return {
      id: null,
      sponsorSearch: '',
      slideSearch: ''
    };
  }),

  on(VirtualEventActions.updateSponsorSearch, (state, { payload: sponsorSearch }) => {
    return { ...state, sponsorSearch };
  }),

  on(VirtualEventActions.updateSlideSearch, (state, { payload: slideSearch }) => {
    return { ...state, slideSearch };
  })

);

export function reducer(state, action) {
  return dataReducer(state, action);
}